import React from "react"
import { makeStyles, createMuiTheme, MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import {
    Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogTitle,
    Grid, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography
} from "@material-ui/core";
import CachedIcon from '@material-ui/icons/Cached';
import AttachmentIcon from '@material-ui/icons/Attachment';
import CloseIcon from '@material-ui/icons/Close'
import ReplayIcon from '@material-ui/icons/Replay';
import { DIYActions } from "../../../actions"
import MUIDataTableHead from "../../custom/MUIDataTableHead";
import TimerOffIcon from '@material-ui/icons/TimerOff';
import Timer3Icon from '@material-ui/icons/Timer3';
import Timer10Icon from '@material-ui/icons/Timer10';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import FolderIcon from '@material-ui/icons/Folder';
import RSSITicketsTable from "./components/RSSITicketsTable"

const useStyles = makeStyles((theme) => ({
    rootDesktop: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(10),
        marginRight: theme.spacing(10),
    },
    rootTablet: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(5),
        marginRight: theme.spacing(5),
    },
    rootMobile: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
    coloredpaper: {
        color: theme.palette.text.secondary,
        backgroundColor: "#303030",
    },
    commentCard: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    }
}));

const AutoRefreshIcons = {
    BLOCKED: TimerOffIcon,
    TIMER3SEC: Timer3Icon,
    TIMER10SEC: Timer10Icon,
}

const autoRefreshStates = {
    0: "BLOCKED",
    1: "TIMER3SEC",
    2: "TIMER10SEC",
}

const getNextAutoRefreshState = (currentState) => {
    switch (currentState) {
        case "BLOCKED":
            return autoRefreshStates[1]
        case "TIMER3SEC":
            return autoRefreshStates[2]
        case "TIMER10SEC":
            return autoRefreshStates[0]
        default: return autoRefreshStates[0]
    }
}

const AutoRefreshIcon = ({ currentState }) => {
    const Icon = AutoRefreshIcons[currentState]
    return <Icon />
}

const getAutoRefreshTime = (currentState) => {
    switch (currentState) {
        case "BLOCKED":
            return 0
        case "TIMER3SEC":
            return 3000
        case "TIMER10SEC":
            return 10000
        default: return 0
    }
}

const defaults = {
    metadata: { status: 'NEW', data: { columns: {} } },
    data: { status: 'NEW', data: { data: [], count: 0 } },
    pagination: { page: 0, pagesize: 20 },
}

const getMuiTheme = (theme) => createMuiTheme({ ...theme, overrides: { ...theme.overrides, MUIDataTableFilter: { root: { backgroundColor: theme.palette.background.secondary } } } });

const TicketActionDialog = withStyles((theme) => ({ root: {}, paper: {} }), { withTheme: true })((props) => <Dialog fullScreen onClose={() => onClose({})} {...props} />);

const TicketsDesktopMode = ({ columns, options, data, MUIDatatableComponents }) => { return <MuiThemeProvider theme={getMuiTheme}><MUIDataTable key='tickets-table' data={data.data.data} columns={columns} options={options} components={MUIDatatableComponents} /></MuiThemeProvider> }

const TicketsTabletMode = ({ columns, options, data, MUIDatatableComponents }) => { return <MuiThemeProvider theme={getMuiTheme}><MUIDataTable key='tickets-table' data={data.data.data} columns={columns} options={options} components={MUIDatatableComponents} /></MuiThemeProvider> }

const TicketsMobileMode = ({ columns, options, data, MUIDatatableComponents }) => { return <MuiThemeProvider theme={getMuiTheme}><MUIDataTable key='tickets-table' data={data.data.data} columns={columns} options={options} components={MUIDatatableComponents} /></MuiThemeProvider> }

const TicketActionDialogMobileMode = ({ selectedRow, onClose }) => {
    const classes = useStyles()
    const [showDetails, setShowDetails] = React.useState(false)

    return (
        <TicketActionDialog open={Object.keys(selectedRow).length > 0} onClose={onClose}>
            <DialogTitle>
                <Grid container direction={'row'} justify={'space-between'}>
                    <Grid item><Typography variant='h4' color='textSecondary'>{selectedRow.sitename} - {selectedRow.reason_for_ticket}</Typography></Grid>
                    <Grid item><Tooltip title={<Typography variant="h5" color="textSecondary">Close</Typography>}><IconButton aria-label="close" className={classes.closeButton} onClick={() => onClose({})}><CloseIcon /></IconButton></Tooltip></Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                    <Grid item><Typography variant="h4" color="textSecondary">Workorder: {selectedRow.Workorder}</Typography></Grid>
                    <Grid item style={{ marginTop: '30px' }}>
                        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                            <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">PreCheck: </Typography></Grid>
                            {
                                selectedRow.PreCheck === 'REQUESTED' ? (
                                    <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                ) : String(selectedRow.PreCheck).split("|")[0] === "ERROR" ? (
                                    <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(selectedRow.PreCheck).split("|")[1]}</Typography></Grid>
                                ) : selectedRow.PreCheck === 'COMPLETED' ? (
                                    <Grid item style={{ width: '160px' }}><Typography variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{selectedRow.PreCheck}</Typography></Grid>
                                ) : null
                            }
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                            <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">StatusCheck: </Typography></Grid>
                            {
                                selectedRow.StatusCheck === null ? (
                                    <Grid item style={{ width: '100px' }}><Button size="small" variant="contained" color="primary" fullWidth disabled={selectedRow.PreCheck !== 'COMPLETED'}><Typography variant="h6" color="textSecondary">EXECUTE</Typography></Button></Grid>
                                ) : selectedRow.StatusCheck === 'PENDING' ? (
                                    <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                ) : String(selectedRow.PreCheck).split("|")[0] === "ERROR" ? (
                                    <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(selectedRow.PreCheck).split("|")[1]}</Typography></Grid>
                                ) : selectedRow.StatusCheck === 'COMPLETED' ? (
                                    <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{selectedRow.StatusCheck}</Typography></Grid>
                                ) : null
                            }
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                            <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">PostCheck: </Typography></Grid>
                            {
                                selectedRow.PostCheck === null ? (
                                    <Grid item style={{ width: '100px' }}><Button size="small" variant="contained" color="primary" fullWidth disabled={selectedRow.StatusCheck !== 'COMPLETED'}><Typography variant="h6" color="textSecondary">EXECUTE</Typography></Button></Grid>
                                ) : selectedRow.PostCheck === 'PENDING' ? (
                                    <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                ) : String(selectedRow.PreCheck).split("|")[0] === "ERROR" ? (
                                    <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(selectedRow.PreCheck).split("|")[1]}</Typography></Grid>
                                ) : selectedRow.PostCheck === 'COMPLETED' ? (
                                    <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{selectedRow.PostCheck}</Typography></Grid>
                                ) : null
                            }
                        </Grid>
                    </Grid>
                    {
                        selectedRow.PostCheck === 'COMPLETED' ? (
                            <Grid item style={{ width: '100%', marginTop: '30px' }}><Button size="small" variant="contained" color="primary" fullWidth><Typography variant="h6" color="textSecondary">Close Ticket</Typography></Button></Grid>
                        ) : null
                    }
                    <Grid item style={{ width: '100%' }}><Button size="small" variant="contained" color="primary" fullWidth onClick={() => setShowDetails(!showDetails)}><Typography variant="h6" color="textSecondary">{showDetails ? 'Hide' : 'Show'} Comments</Typography></Button></Grid>
                    {showDetails ? <Grid item><DetailsRow row={selectedRow} isMobile={true} /></Grid> : null}
                </Grid>
            </DialogContent>
        </TicketActionDialog>
    )
}

const DetailsRow = ({ row, isMobile = false }) => {
    const classes = useStyles()
    const [details, setDetails] = React.useState({ status: "NEW", data: { comments: [] } })

    const getDetails = () => {
        setDetails({ status: "PENDING", data: { comments: [] } })
        DIYActions.Ticket.getDetails(row.id).then((response) => setDetails(response.data)).catch((error) => {
            setDetails({ status: "NEW", data: { comments: [] } })
        })
    }

    React.useEffect(() => getDetails(), [])

    return (
        details.status === "SUCCESS" ? (
            <Paper className={classes.coloredpaper} style={{ overflowX: 'hidden', overflowY: 'scroll', width: '100%', height: isMobile ? '40vh' : '30vh' }}>
                <Grid container direction='column' justify='flex-start' alignItems='stretch' spacing={1}>
                    {
                        details.data.comments.map((comment, index) => (
                            <Grid item>
                                <Card className={classes.commentCard}>
                                    <CardHeader
                                        style={{ paddingTop: 0, paddingBottom: 0 }}
                                        disableTypography={true}
                                        title={<Typography variant="h5" color="textSecondary">{comment.CreatedBy} — {comment.Timestamp}</Typography>}
                                        subheader={<Typography className={classes.inline} variant="h6" color="textSecondary">Activity: {String(comment.Action).substring(0, 1) + String(comment.Action).toLowerCase().substring(1, String(comment.Action).length).replace("check", " Check")}</Typography>}
                                    />
                                    <CardContent style={{ paddingTop: 0, paddingBottom: 0 }}><Typography className={classes.inline} variant="h6" color="textSecondary">Comment: {comment.Comment}</Typography></CardContent>
                                </Card>
                            </Grid>
                        ))
                    }
                </Grid>
            </Paper>
        ) : details.status === "PENDING" ? (
            <LinearProgress />
        ) : details.status === "ERROR" ? (
            <Typography variant="h5" color="secondary">Details not available at the moment. Please try again later</Typography>
        ) : null
    )

}

const ExpandedRow = ({ index, rowData, rowDataUpadte, openReport, onAction, refresh, getHardwareReport }) => {
    const [expandMore, setExpandMore] = React.useState({ comments: false, rssitickets: false })

    const expand = {
        comments: () => setExpandMore((current) => { return { ...current, comments: !current.comments } }),
        rssitickets: () => setExpandMore((current) => { return { ...current, rssitickets: !current.rssitickets } }),
    }

    const data = rowDataUpadte === undefined ? rowData : rowDataUpadte

    return (
        <React.Fragment>
            <TableRow>
                <TableCell colSpan={2}>
                    <Grid container direction="column" justify="flex-start" alignItems="center" spacing={2}>
                        <Grid item><Typography variant="h4" color="textSecondary">ESPID: {data.Workorder}</Typography></Grid>
                        <Grid item><Typography variant="h4" color="textSecondary">WOID: {data.QuantumWorkorder}</Typography></Grid>
                    </Grid>
                </TableCell>
                <TableCell colSpan={5}>
                    {
                        String(data.tickettype).toLowerCase() === "FCO".toLowerCase() ? (
                            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                                <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                                    <Grid item><Typography variant="h5" color="textSecondary">IMT Ticket: {data.IMT}</Typography></Grid>
                                </Grid>
                            </Grid>
                        ) : String(data.tickettype).toUpperCase().startsWith("B2B") ? (
                            data.tickettype_parts.includes("EESI_EMAIL") ? (
                                <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                                    <Grid item><Typography variant="h5" color="textSecondary">IMT Ticket: {data.IMT}</Typography></Grid>
                                </Grid>
                            ) : data.tickettype_parts.includes("NRO_TAC_EMAIL") ? (
                                <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                                    <Grid item><Typography variant="h5" color="textSecondary">IMT Ticket: {data.IMT}</Typography></Grid>
                                </Grid>
                            ) : data.tickettype_parts.includes("IMT_TICKETS") ? (
                                <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                                    <Grid item><Typography variant="h5" color="textSecondary">IMT Ticket: {data.IMT}</Typography></Grid>
                                </Grid>
                            ) : data.tickettype_parts.includes("AUTOMATION") ? (
                                <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                                    <Grid item>
                                        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                            <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">PreCheck: </Typography></Grid>
                                            {
                                                data.PreCheck === 'REQUESTED' ? (
                                                    <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                                ) : String(data.PreCheck).split("|")[0] === "ERROR" ? (
                                                    <React.Fragment>
                                                        <Grid item style={{ width: '160px' }}><Button size="small" variant="contained" color="primary" disabled={!data.PreCheckRetry} fullWidth startIcon={<ReplayIcon />} onClick={() => onAction(index, data, "PreCheck")}><Typography variant="h6" color="textSecondary">Retry</Typography></Button></Grid>
                                                        <Grid item><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(data.PreCheck).split("|")[1]}</Typography></Grid>
                                                    </React.Fragment>
                                                ) : data.PreCheck === 'COMPLETED' ? (
                                                    <React.Fragment>
                                                        <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{data.PreCheck}</Typography></Grid>
                                                        <Grid item style={{ width: '100px' }}></Grid>
                                                        <Grid item style={{ width: '160px' }}><Tooltip title={<Typography variant="h5" color="textSecondary">View Report</Typography>}><IconButton size="small" onClick={() => openReport({ data: data, reporttype: "PRECHECK" })}><AttachmentIcon /></IconButton></Tooltip></Grid>
                                                    </React.Fragment>
                                                ) : null
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                            <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">StatusCheck: </Typography></Grid>
                                            {
                                                data.StatusCheck === null ? (
                                                    <Grid item style={{ width: '160px' }}><Button size="small" variant="contained" color="primary" fullWidth disabled={data.PreCheck !== 'COMPLETED'} onClick={() => onAction(index, data, "StatusCheck")}><Typography variant="h6" color="textSecondary">EXECUTE</Typography></Button></Grid>
                                                ) : data.StatusCheck === 'PENDING' ? (
                                                    <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                                ) : String(data.PreCheck).split("|")[0] === "ERROR" ? (
                                                    <Grid item><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(data.PreCheck).split("|")[1]}</Typography></Grid>
                                                ) : data.StatusCheck === 'COMPLETED' ? (
                                                    <React.Fragment>
                                                        <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{data.StatusCheck}</Typography></Grid>
                                                        <Grid item style={{ width: '100px' }}><Button size="small" variant="contained" color="primary" fullWidth startIcon={<ReplayIcon />} onClick={() => onAction(index, data, "StatusCheck")}><Typography variant="h6" color="textSecondary">Rerun</Typography></Button></Grid>
                                                        <Grid item style={{ width: '160px' }}><Tooltip title={<Typography variant="h5" color="textSecondary">View Reports</Typography>}><IconButton size="small" onClick={() => openReport({ data: data, reporttype: "STATUSCHECK" })}><AttachmentIcon /></IconButton></Tooltip></Grid>
                                                    </React.Fragment>
                                                ) : null
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                            <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">PostCheck: </Typography></Grid>
                                            {
                                                data.PostCheck === null ? (
                                                    <Grid item style={{ width: '160px' }}><Button size="small" variant="contained" color="primary" fullWidth disabled={data.PreCheck !== 'COMPLETED'} onClick={() => onAction(index, data, "PostCheck")}><Typography variant="h6" color="textSecondary">EXECUTE</Typography></Button></Grid>
                                                ) : data.PostCheck === 'PENDING' ? (
                                                    <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                                ) : String(data.PreCheck).split("|")[0] === "ERROR" ? (
                                                    <Grid item><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(data.PreCheck).split("|")[1]}</Typography></Grid>
                                                ) : data.PostCheck === 'COMPLETED' ? (
                                                    <React.Fragment>
                                                        <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{data.PostCheck}</Typography></Grid>
                                                        <Grid item style={{ width: '100px' }}><Button size="small" variant="contained" color="primary" fullWidth startIcon={<ReplayIcon />} onClick={() => onAction(index, data, "PostCheck")}><Typography variant="h6" color="textSecondary">Rerun</Typography></Button></Grid>
                                                        <Grid item style={{ width: '160px' }}><Tooltip title={<Typography variant="h5" color="textSecondary">View Reports</Typography>}><IconButton size="small" onClick={() => openReport({ data: data, reporttype: "POSTCHECK" })}><AttachmentIcon /></IconButton></Tooltip></Grid>
                                                    </React.Fragment>
                                                ) : null
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ) : null
                        ) : (
                            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">PreCheck: </Typography></Grid>
                                        {
                                            data.PreCheck === 'REQUESTED' ? (
                                                <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                            ) : String(data.PreCheck).split("|")[0] === "ERROR" ? (
                                                <React.Fragment>
                                                    <Grid item style={{ width: '160px' }}><Button size="small" variant="contained" color="primary" disabled={!data.PreCheckRetry} fullWidth startIcon={<ReplayIcon />} onClick={() => onAction(index, data, "PreCheck")}><Typography variant="h6" color="textSecondary">Retry</Typography></Button></Grid>
                                                    <Grid item><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(data.PreCheck).split("|")[1]}</Typography></Grid>
                                                </React.Fragment>
                                            ) : data.PreCheck === 'COMPLETED' ? (
                                                <React.Fragment>
                                                    <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{data.PreCheck}</Typography></Grid>
                                                    <Grid item style={{ width: '100px' }}></Grid>
                                                    <Grid item style={{ width: '160px' }}><Tooltip title={<Typography variant="h5" color="textSecondary">View Report</Typography>}><IconButton size="small" onClick={() => openReport({ data: data, reporttype: "PRECHECK" })}><AttachmentIcon /></IconButton></Tooltip></Grid>
                                                </React.Fragment>
                                            ) : null
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">StatusCheck: </Typography></Grid>
                                        {
                                            data.StatusCheck === null ? (
                                                <Grid item style={{ width: '160px' }}><Button size="small" variant="contained" color="primary" fullWidth disabled={data.PreCheck !== 'COMPLETED'} onClick={() => onAction(index, data, "StatusCheck")}><Typography variant="h6" color="textSecondary">EXECUTE</Typography></Button></Grid>
                                            ) : data.StatusCheck === 'PENDING' ? (
                                                <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                            ) : String(data.PreCheck).split("|")[0] === "ERROR" ? (
                                                <Grid item><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(data.PreCheck).split("|")[1]}</Typography></Grid>
                                            ) : data.StatusCheck === 'COMPLETED' ? (
                                                <React.Fragment>
                                                    <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{data.StatusCheck}</Typography></Grid>
                                                    <Grid item style={{ width: '100px' }}><Button size="small" variant="contained" color="primary" fullWidth startIcon={<ReplayIcon />} onClick={() => onAction(index, data, "StatusCheck")}><Typography variant="h6" color="textSecondary">Rerun</Typography></Button></Grid>
                                                    <Grid item style={{ width: '160px' }}><Tooltip title={<Typography variant="h5" color="textSecondary">View Reports</Typography>}><IconButton size="small" onClick={() => openReport({ data: data, reporttype: "STATUSCHECK" })}><AttachmentIcon /></IconButton></Tooltip></Grid>
                                                </React.Fragment>
                                            ) : null
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: '150px' }}><Typography variant="h5" color="textSecondary">PostCheck: </Typography></Grid>
                                        {
                                            data.PostCheck === null ? (
                                                <Grid item style={{ width: '160px' }}><Button size="small" variant="contained" color="primary" fullWidth disabled={data.PreCheck !== 'COMPLETED'} onClick={() => onAction(index, data, "PostCheck")}><Typography variant="h6" color="textSecondary">EXECUTE</Typography></Button></Grid>
                                            ) : data.PostCheck === 'PENDING' ? (
                                                <Grid item style={{ width: '160px' }}><LinearProgress /></Grid>
                                            ) : String(data.PreCheck).split("|")[0] === "ERROR" ? (
                                                <Grid item><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#FF0000' }}>{String(data.PreCheck).split("|")[1]}</Typography></Grid>
                                            ) : data.PostCheck === 'COMPLETED' ? (
                                                <React.Fragment>
                                                    <Grid item style={{ width: '160px' }}><Typography align="center" variant="h5" color="textSecondary" style={{ color: '#43A047' }}>{data.PostCheck}</Typography></Grid>
                                                    <Grid item style={{ width: '100px' }}><Button size="small" variant="contained" color="primary" fullWidth startIcon={<ReplayIcon />} onClick={() => onAction(index, data, "PostCheck")}><Typography variant="h6" color="textSecondary">Rerun</Typography></Button></Grid>
                                                    <Grid item style={{ width: '160px' }}><Tooltip title={<Typography variant="h5" color="textSecondary">View Reports</Typography>}><IconButton size="small" onClick={() => openReport({ data: data, reporttype: "POSTCHECK" })}><AttachmentIcon /></IconButton></Tooltip></Grid>
                                                </React.Fragment>
                                            ) : null
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    }
                </TableCell>
                <TableCell style={{ width: "150px" }}>
                    <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={2}>
                        <Grid item><Button variant="contained" color="primary" size="small" fullWidth startIcon={expandMore.comments ? <FolderOpenIcon /> : <FolderIcon />} onClick={() => expand.comments()}><Typography variant="h6" color="textSecondary">Comments</Typography></Button></Grid>
                        <Grid item><Button variant="contained" color="primary" size="small" fullWidth disabled={data.rssiTickets.length === 0} startIcon={expandMore.rssitickets ? <FolderOpenIcon /> : <FolderIcon />} onClick={() => expand.rssitickets()}><Typography variant="h6" color="textSecondary">RSSI Tickets</Typography></Button></Grid>
                    </Grid>
                </TableCell>
                <TableCell style={{ width: "150px" }}><Button size="small" variant="contained" color="primary" fullWidth onClick={() => onAction(index, data, "CLOSE")}><Typography variant="h6" color="textSecondary">Close Ticket</Typography></Button></TableCell>
            </TableRow>
            {expandMore.comments ? <TableRow><TableCell colSpan={10}><DetailsRow row={data} /></TableCell></TableRow> : null}
            {expandMore.rssitickets ? <RSSITicketsTable tickets={data.rssiTickets} refresh={refresh} /> : null}
        </React.Fragment>
    )
}

const Tickets = ({ profile, responsive, openReport }) => {
    const classes = useStyles()
    const [metadata, setMetadata] = React.useState(defaults.metadata)
    const [data, setData] = React.useState(defaults.data)
    const [dataUpdate, setDataUpdate] = React.useState(defaults.data)
    const [pagination, setPagination] = React.useState(defaults.pagination)
    const [filters, setFilters] = React.useState({})
    const [actionExecutionData, setActionExecutionData] = React.useState({ index: -1, row: {}, action: "", status: "NEW" })
    const [hardwareReport, setHardwareReport] = React.useState({ open: false, status: "NEW", data: [] })
    const [actionComment, setActionComment] = React.useState("")
    const [actionCommentError, setActionCommentError] = React.useState(false)
    const [selectedRow, setSelectedRow] = React.useState({});
    const [autoRefreshState, setAutoRefreshState] = React.useState(autoRefreshStates[2])
    const [autoRefreshStateInterval, setAutoRefreshStateInterval] = React.useState(null)
    const [doRefresh, setDoRefresh] = React.useState(false)

    React.useEffect(() => DIYActions.TicketSearch.getMetadata(setMetadata), [])

    const fetchTickets = (paging, setData) => {
        var _filters = { ticketstatus: 'OPEN', username: profile.username, tickettype: profile.accounttype }
        if (profile.accesslvl === "admin") {
            _filters = { ticketstatus: 'OPEN', tickettype: profile.accounttype, username: "%", customer: profile.customer, company: profile.company }
        } else if (profile.accesslvl === "superadmin") {
            _filters = { ticketstatus: 'OPEN', username: "%" }
        }
        DIYActions.TicketSearch.getTickets(paging, { ..._filters, ...filters }, setData)
    }

    const getTicketsAuto = (paging) => {
        setDataUpdate({ ...dataUpdate, status: 'WORKING' })
        fetchTickets(paging, setDataUpdate)
    }

    React.useEffect(() => {
        var interval = null
        if (autoRefreshStateInterval !== null) {
            clearInterval(autoRefreshStateInterval)
        }
        if (autoRefreshState !== "BLOCKED") {
            interval = setInterval(() => setDoRefresh(true), getAutoRefreshTime(autoRefreshState));
            setAutoRefreshStateInterval(interval)
        } else {
            setAutoRefreshStateInterval(null)
        }
        return interval !== null ? () => clearInterval(interval) : () => { }
    }, [autoRefreshState])

    React.useEffect(() => {
        if (autoRefreshState !== "BLOCKED" && doRefresh) {
            getTicketsAuto(pagination)
            setDoRefresh(false)
        }
    }, [doRefresh])

    const getTickets = (paging) => {
        setData({ status: 'WORKING', data: { data: [], count: 0 } })
        fetchTickets(paging, setData)
    }

    const onPaginationChange = (newPagination) => {
        setPagination(newPagination)
        getTickets(newPagination)
    }

    const column_info = [
        { name: "sitename", sort: true, searchable: true, filter: false, display: true },
        { name: "customer", sort: true, searchable: true, filter: profile.accesslvl === "superadmin", display: responsive.isMobile ? false : true },
        { name: "region", sort: true, searchable: true, filter: true, display: responsive.isMobile ? false : true },
        { name: "market", sort: true, searchable: true, filter: true, display: responsive.isMobile ? false : true },
        { name: "tickettype", sort: true, searchable: true, filter: true, display: responsive.isMobile ? false : true },
        { name: "reason_for_ticket", sort: true, searchable: true, filter: true, display: responsive.isMobile ? false : true },
        { name: "username", sort: true, searchable: false, filter: false, display: false },
        { name: "ticketstatus", sort: true, searchable: true, filter: false, display: true },
        { name: "timestamp", sort: true, searchable: false, filter: false, display: responsive.isMobile ? false : true },
    ]

    const columns = column_info.map((col) => (
        {
            name: col.name,
            label: metadata.data.columns[col.name],
            options: {
                display: col.display,
                sort: col.sort,
                searchable: col.searchable,
                filter: col.filter,
                setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap", backgroundColor: "#0a0a0c", fontSize: "1rem", fontWeight: 700 } }),
                setCellProps: () => ({ style: { fontWeight: 500, fontSize: "1rem", letterSpacing: "-0.05px", lineHeight: "20px", color: "#FFFFFF" } }),
            }
        }
    ))

    const CustomTableFilterList = (props) => {
        const CustomChip = ({ index, label, onDelete }) => { return <Chip style={{ marginRight: 10, marginBottom: 10 }} variant="outlined" color="secondary" label={String(columns[index].label) + ': ' + String(label)} onDelete={onDelete} /> }
        return <TableFilterList {...props} ItemComponent={CustomChip} />
    }

    const MUIDatatableComponents = { TableFilterList: CustomTableFilterList, TableHead: MUIDataTableHead }

    var options = {
        count: data.data.count,
        page: pagination.page,
        elevation: 16,
        rowsPerPage: pagination.pagesize,
        rowsPerPageOptions: [10, 20, 50],
        selectableRows: "none",
        searchPlaceholder: "Sitename, Customer, Region, Market, Ticket Reason",
        download: false,
        print: false,
        viewColumns: false,
        reload: true,
        serverSide: true,
        textLabels: {
            body: {
                noMatch: "No open tickets",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            },
            pagination: {
                next: "Next",
                previous: "Previous",
                rowsPerPage: "Pagesize:",
                displayRows: "of",
            },
            filter: {
                all: "All",
                title: "FILTERS",
            },
        },
        responsive: "standard",
        expandableRows: !responsive.isMobile,
        expandableRowsHeader: false,
        expandableRowsOnClick: !responsive.isMobile,
        onRowClick: responsive.isMobile ? (_, rowState) => setSelectedRow(data.data.data[rowState.dataIndex]) : (_, rowState) => { },
        customToolbar: () => {
            return (
                <React.Fragment>
                    <Tooltip title={<Typography variant="h5" color="textSecondary">Reload Table</Typography>} disableFocusListener><IconButton style={data.status === 'WORKING' || dataUpdate.status === 'WORKING' ? { animation: 'logo-spin infinite 1s linear' } : {}} onClick={() => getTickets(pagination)}><CachedIcon /></IconButton></Tooltip>
                    <Tooltip title={<Typography variant="h5" color="textSecondary">Auto Refresh</Typography>} disableFocusListener><IconButton onClick={() => setAutoRefreshState(getNextAutoRefreshState(autoRefreshState))}><AutoRefreshIcon currentState={autoRefreshState} /></IconButton></Tooltip>
                </React.Fragment>
            )
        },
        handleReload: () => getTickets(pagination),
        onChangeRowsPerPage: (numberOfRows) => onPaginationChange({ ...pagination, pagesize: numberOfRows }),
        onChangePage: (currentPage) => onPaginationChange({ ...pagination, page: currentPage }),
        onTableInit: () => getTickets(pagination),
        onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {
            if (changedColumn === null) {
                setFilters({ ...(profile.accesslvl === "superadmin" ? { username: "*" } : profile.accesslvl === "admin" ? { username: "*", customer: profile.customer, company: profile.company } : { username: profile.username }), ticketstatus: 'OPEN' })
            } else {
                if (filterList[changedColumnIndex].length > 0) {
                    setFilters({ ...filters, [changedColumn]: filterList[changedColumnIndex][0] })
                } else {
                    let _filters = filters
                    delete _filters[changedColumn]
                    setFilters(_filters)
                }
            }
        },
    };

    const updateData = (key, value, index, row) => {
        row = { ...row, [key]: value }
        var rows = data.data.data
        rows[index] = row
        var dataInt = data
        dataInt = { ...dataInt, data: { ...dataInt.data, data: rows } }
        setData(dataInt)
    }

    const executeActionInit = (index, row, action) => setActionExecutionData({ index, row, action, status: "NEW" })

    const executeAction = (index, row, action) => {
        if (actionComment.length > 3) {
            setActionCommentError(false)
            setActionExecutionData({ ...actionExecutionData, status: "PENDING" })
            DIYActions.Ticket.executeAction({ ...row, action: String(action).toUpperCase(), comment: actionComment }).then((response) => {
                if (response.data.status === "SUCCESS") {
                    updateData(action, "PENDING", index, row)
                    setActionComment("")
                    setActionCommentError(false)
                    setActionExecutionData({ index: -1, row: {}, action: "", status: "NEW" })
                    if (action === "CLOSE") {
                        setPagination({ ...defaults.pagination, pagesize: pagination.pagesize })
                        getTickets({ ...defaults.pagination, pagesize: pagination.pagesize })
                    }
                }
            }).catch(console.error)
            setActionCommentError(true)
        }
    }

    const getHardwareReport = (sitename) => {
        setHardwareReport({ open: true, status: "WORKING", data: [] })
        DIYActions.Reports.getHardwareReport(sitename).then((response) => {
            if (response.data.status === "SUCCESS") {
                setHardwareReport({ open: true, status: "SUCCESS", data: response.data.data })
            }
        }).catch(console.error)
    }

    const refresh = () => getTicketsAuto(pagination)

    if (!responsive.isMobile) {
        options = {
            ...options,
            renderExpandableRow: (_, rowMeta) => { return <ExpandedRow index={rowMeta.dataIndex} rowData={data.data.data[rowMeta.dataIndex]} rowDataUpadte={dataUpdate.data.data[rowMeta.dataIndex]} openReport={openReport} onAction={executeActionInit} getHardwareReport={getHardwareReport} refresh={refresh} /> },
        }
    }

    const viewProps = { columns, data, options, MUIDatatableComponents, onStateChange: ({ state }) => setVisibleColumns(state) }

    return (
        <React.Fragment>
            {responsive.isMobile ? <TicketsMobileMode {...viewProps} /> : responsive.isTablet ? <TicketsTabletMode {...viewProps} /> : <TicketsDesktopMode {...viewProps} />}
            {responsive.isMobile ? <TicketActionDialogMobileMode selectedRow={selectedRow} onClose={setSelectedRow} /> : null}
            <Dialog open={actionExecutionData.index !== -1} fullWidth fullScreen={responsive.isMobile}>
                <DialogTitle disableTypography={true}>
                    <Grid container direction={'row'} justify={'space-between'}>
                        <Grid item><Typography variant="h4" color="textSecondary">{actionExecutionData.action}</Typography></Grid>
                        <Grid item><Tooltip title={<Typography variant="h5" color="textSecondary">Close</Typography>}><IconButton aria-label="close" color="secondary" className={classes.closeButton} onClick={() => {
                            setActionComment("")
                            setActionCommentError(false)
                            setActionExecutionData({ index: -1, row: {}, action: "" })
                        }}><CloseIcon /></IconButton></Tooltip></Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item style={{ width: "100px" }}><Typography variant="h5" color="textSecondary">Source: </Typography></Grid>
                                <Grid item style={{ width: "450px" }}><Typography variant="h6" color="textSecondary">{actionExecutionData.row.sitename} - {actionExecutionData.row.Workorder}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                                <Grid item style={{ width: "100px" }}><Typography variant="h5" color="textSecondary">Comments: </Typography></Grid>
                                <Grid item style={{ width: "450px" }}><TextField variant="outlined" rowsMax={8} rows={5} multiline fullWidth error={actionCommentError} value={actionComment} onChange={(e) => setActionComment(e.target.value)} /></Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="small" variant="contained" disabled={actionExecutionData.status === "PENDING"} color="primary" onClick={() => executeAction(actionExecutionData.index, actionExecutionData.row, actionExecutionData.action)}><Typography variant="h6" color="textSecondary">Execute {actionExecutionData.action}</Typography></Button>
                </DialogActions>
            </Dialog>
            <Dialog open={hardwareReport.open} fullWidth maxWidth="md">
                <DialogTitle disableTypography={true}>
                    <Grid container direction={'row'} justify={'space-between'}>
                        <Grid item><Typography variant="h4" color="textSecondary">Hardware Report</Typography></Grid>
                        <Grid item><Tooltip title={<Typography variant="h5" color="textSecondary">Close</Typography>}><IconButton aria-label="close" color="secondary" className={classes.closeButton} onClick={() => setHardwareReport({ open: false, status: "NEW", data: [] })}><CloseIcon /></IconButton></Tooltip></Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    {
                        hardwareReport.status === "ERROR" ? (
                            <Typography variant="h5" color="secondary">Something went wrong, Try again later.</Typography>
                        ) : hardwareReport.status === "WORKING" ? (
                            <LinearProgress />
                        ) : hardwareReport.status === "SUCCESS" ? (
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell variant="head" size="small" align="center"><Typography variant="h5" color="textSecondary">Hardware Id</Typography></TableCell>
                                            <TableCell variant="head" size="small" align="center"><Typography variant="h5" color="textSecondary">Current Serial Number</Typography></TableCell>
                                            <TableCell variant="head" size="small" align="center"><Typography variant="h5" color="textSecondary">Faulty Serial Number</Typography></TableCell>
                                            <TableCell variant="head" size="small" align="center"><Typography variant="h5" color="textSecondary">Status</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            hardwareReport.data.map((record) => (
                                                <TableRow style={record["Status"] === "Active" ? { backgroundColor: "#00c853" } : { backgroundColor: "#FF1744" }}>
                                                    <TableCell variant="body" size="small" align="center"><Typography variant="h5" color="textSecondary">{record["HardwareId"]}</Typography></TableCell>
                                                    <TableCell variant="body" size="small" align="center"><Typography variant="h5" color="textSecondary">{record["Current Serial Number"]}</Typography></TableCell>
                                                    <TableCell variant="body" size="small" align="center"><Typography variant="h5" color="textSecondary">{record["Faulty Serial Number"]}</Typography></TableCell>
                                                    <TableCell variant="body" size="small" align="left"><Typography variant="h5" color="textSecondary">{record["Status"]} {String(record["Status"]).toLowerCase() === "active" ? "(Dispatch Required)" : String(record["Status"]).toLowerCase() === "removed" ? "(No Dispatch Required)" : null}</Typography></TableCell>
                                                </TableRow>
                                            ))
                                        }
                                        {hardwareReport.data.length === 0 ? <TableRow><TableCell variant="body" size="small" align="center" colSpan={4}><Typography variant="h5" align="center" noWrap color="textSecondary">NO ACTIVE HARDWARE FAULT</Typography></TableCell></TableRow> : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : null
                    }
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default Tickets
